<template>
  <div>
    <el-dialog
      title="最高报价分布"
      :visible.sync="visible"
      :close-on-click-modal="false"
      width="1200px"
    >
      <div style="margin-bottom: 20px">
        <span>{{ className() }}-{{ row.brandName }}</span>
        <span style="margin-left: 30px">机型：{{ row.modelName }}</span>
      </div>

      <el-table v-if="visible" v-loading="loading" :data="list" :default-sort="sort" border @sort-change="handleSortChange">
        <el-table-column type="index" label="序号" width="70" align="center" :index="(index)=> (index+1) + (pageNum-1)*pageSize" />
        <el-table-column label="回收商名称" prop="merchantName" align="center" />
        <el-table-column label="推送订单" prop="inquiryCount" align="center" sortable="custom" :sort-orders="['descending', 'ascending']" />
        <el-table-column label="报价量" prop="quoteCount" align="center" sortable="custom" :sort-orders="['descending', 'ascending']" />
        <el-table-column label="拒绝报价量" prop="rejectQuoteCount" sortable="custom" :sort-orders="['descending', 'ascending']" align="center">
          <template slot-scope="{ row }">
            <el-link v-if="row.rejectQuoteCount" type="danger" :underline="false">{{row.rejectQuoteCount}}</el-link>
            <span v-else>0</span>
          </template>
        </el-table-column>
        <el-table-column label="低价拒绝量" prop="rejectLowQuoteNum" sortable="custom" :sort-orders="['descending', 'ascending']" align="center">
          <template slot-scope="{ row }">
            <el-link v-if="row.rejectLowQuoteNum" type="danger" :underline="false">{{row.rejectLowQuoteNum}}</el-link>
            <span v-else>0</span>
          </template>
        </el-table-column>
        <el-table-column label="有效报价量" prop="normalQuoteNum" align="center" sortable="custom" :sort-orders="['descending', 'ascending']" />
        <el-table-column label="报价率" prop="quoteRate" align="center" sortable="custom" :sort-orders="['descending', 'ascending']">
          <template slot-scope="{ row }">
            {{ row.quoteRate }}%
          </template>
        </el-table-column>
        <el-table-column label="最高报价量" prop="maxQuoteCount" align="center" sortable="custom" :sort-orders="['descending', 'ascending']" />
        <el-table-column label="最高报价率" prop="maxQuoteRate" align="center" sortable="custom" :sort-orders="['descending', 'ascending']">
          <template slot="header">
         最高报价率
          <el-tooltip
            class="item"
            effect="dark"
            content="最高报价量/有效报价量*100%"
            placement="top"
          >
            <i class="el-icon-warning-outline" />
          </el-tooltip>
        </template>
          <template slot-scope="{ row }">
            {{ row.maxQuoteRate }}%
          </template>
        </el-table-column>
        <!-- <el-table-column label="拒绝报价量" prop="rejectQuoteCount" align="center" sortable="custom" :sort-orders="['descending', 'ascending']" /> -->
        <el-table-column label="成交量" prop="dealCount" align="center" sortable="custom" :sort-orders="['descending', 'ascending']" />
        <el-table-column label="成交率" prop="dealRate" align="center" sortable="custom" :sort-orders="['descending', 'ascending']">
          <template slot-scope="{ row }">
            {{ row.dealRate }}%
          </template>
        </el-table-column>
        <el-table-column label="累计交易金额" prop="dealAmount" align="center" sortable="custom" :sort-orders="['descending', 'ascending']" />
        <el-table-column label="操作" fixed="right" align="center">
          <template slot-scope="{ row }">
            <el-link type="primary" @click="$refs['modelTankOrderDia'].open(row)">订单明细</el-link>
          </template>
        </el-table-column>
      </el-table>
      <Pagination :pageNum.sync="pageNum" :pageSize.sync="pageSize" :total="total" @pagination="getData" />

    </el-dialog>
    <ModelTankOrderDia ref="modelTankOrderDia" queryType="02" :modelInfo="row" :form="form" />
  </div>
</template>

<script>
import _api from "@/utils/request";
import ModelTankOrderDia from './ModelTankOrderDia.vue';
import { machineQuoteOrderTypes, getSortForm } from '../table/define'
import Pagination from '../Pagination.vue';

export default {
  name: "ModelTankHighDia",
  components: { ModelTankOrderDia, Pagination },
  inject: ['className'],
  props: {
    form: {
      type: Object,
      default: () => ({})
    },
    sort: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      visible: false,
      loading: false,
      pageNum: 1,
      pageSize: 10,
      total: 0,
      list: [],
      sortForm: {},
      row: {}
    };
  },
  methods: {
    open(row) {
      this.row = row
      this.sortForm = getSortForm(this.sort, machineQuoteOrderTypes)
      this.pageNum = 1
      this.visible = true
      this.getData()
    },
    getData() {
      this.loading = true
      _api.machineRankStatisticsQuote({
        ...this.form,
        ...this.sortForm,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        modelId: this.row.modelId,
      }).then(res => {
        this.list = res.data.records
        this.total = res.data.total
      }).finally(() => {
        this.loading = false
      })
    },
    handleSortChange({ order, prop }) {
      // this.sort = { order, prop }

      const sortForm = getSortForm({ order, prop }, machineQuoteOrderTypes)
      this.sortForm = sortForm
      this.getData()
    },
  }
};
</script>